<i18n src="../../../locales/lang.json"></i18n>

<template>
  <div class="card configurator" v-bind:id="getCompId()" style="float:left; width:200px;">
    <div class="card-header bg-dark text-white header-elements-inline">
      <h6 class="card-title">{{$t('Organisation')}}</h6>
      <div class="header-elements">
        <div class="list-icons">
          <a class="list-icons-item" @click="removeMe" data-action="remove"></a>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="container-fluid upload-container p-0">

        <div class="row">
          <div class="col px-0">
            <div class="select_container">
              <select class="form-control select-search" data-fouc v-bind:id="'select_assigned_Organisation_' +  getId()">
                <option value="-1" style="">{{$t('select_organisation')}}</option>
                <option v-for="Organisation in userOrganisations" v-bind:value="Organisation.Organisationid">
                  {{ Organisation.Organization }}
                </option>
              </select>
            </div>           
          </div>
        </div>       
        <div v-if="message != null && message != ''" class="col-12 alert alert-light upload-error-message" role="alert">
          <ul>
            <li class="col-12" v-for="(ms, i) in message.split('\n')" :key="i">
              {{ ms }}
            </li>
          </ul>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-sm-12 px-0">
          <button class="btn btn-success btn-sm col-sm-12" @click="doApply">{{$t('apply')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  var config =
  {
    customstyle: "background-color:#B6E874",
    customclass: "",
    abbreviation: null,
    data: 8,
    icon: "/images/filter_icons/icon-location.png",
    text: "Organisation name"
  }

  export default {
    name: "config-Organisation",
    components: {

    },
    props: {
      enableedit: {
        required: false,
        type: String,
        default: "false"
      },
      type: {
        required: false,
        type: String,
        default: ""
      },
      user: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        config,        
        userOrganisations :[]
      };
    },

    methods: {
      onChange() {
        
      },
      async getUserOrganisations(user) {
        try {
          //this.userOrganisations = [];
          this.$http.get('/api/Organization/v1/User?user=' + user).then(async response => {
            this.userOrganisations = response.data;
            $('#' + 'select_assigned_Organisation_' + this.getId()).select2();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },     
      doApply() {
        var configCopy =
        {
          customstyle: this.config.customstyle,
          customclass: this.config.customclass,
          abbreviation: this.config.abbreviation,
          data: $("#select_assigned_Organisation_" + this.getId()).val(),
          icon: this.config.icon,
          text: $("#select_assigned_Organisation_" + this.getId() +" option:selected").text()
        };

        this.$emit('addFilter', this.type, configCopy);
      },
      getId() {
        return this._uid;
      },
      getCompId() {
        return "child_" + this._uid;
      },
      toggleActivation() {

      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      removeMe() {
        this.$emit('remove', this.getCompId());
      }
    },
    computed: {

    },
    mounted() {      
      this.getUserOrganisations(this.user);
    },

    created: function () {

    },

    watch: {
     
      user: function (newVal, oldVal) {
        if (newVal !== "") {          
          this.getUserOrganisations(newVal);
        }
      }
    },
    created() {
      //this.$root.$on('procedure_refresh', this.handleRefresh);
    },
  };

</script>

<style scoped>
  .configurator {
    margin-left: 15px;
  }

  .card-header.bg-dark {
    background-color: #EAEDEF !important;
    color: black !important;
  }  
  .select_container {
    width: calc(100% - 0px)
  }

  @media screen and (max-width:768px) {
    .card {
      margin-left: 5px !important;
      width: 185px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/filter/configurators/config-organisation.vue